import {
  JobObjectFailure,
  JobObjectFailuresWithCount,
  JobObjectStage
} from '../../../interfaces/job';
import { TableRowSpanningBoxProps } from '../../../../table/interfaces/table';
import styles from './JobObjectStageFailures.module.scss';
import { EntityList } from '../../../../entity-list/EntityList';
import { JobObjectStageFailuresTable } from './JobObjectStageFailuresTable';
import { JobsAPI } from '../../../JobsAPI';
import { ListMetaNetworkParams } from '../../../../list-conductor/list-meta-data';
import { QueryResult } from '../../../../request/hooks/useQuery';
import { JOB_OBJECT_STAGE_FAILURE_STAGE_MAP } from '../../../constants/constants';
import { EntityListEntities } from '../../../../shared/interfaces/entity-list';

export function JobObjectStageFailures({
  row,
  globalContext
}: TableRowSpanningBoxProps<JobObjectStage, { jobId: string; objectId: string }>) {
  if (!row.data.hasFailures) {
    return null;
  }

  const fetch = (params?: ListMetaNetworkParams): Promise<QueryResult<Array<JobObjectFailure>>> => {
    const jobId = globalContext?.jobId as string;
    const objectId = globalContext?.objectId as string;
    const stage = JOB_OBJECT_STAGE_FAILURE_STAGE_MAP[row.data.stage];

    return JobsAPI.getObjectLevelFailures(jobId, objectId, stage, params).then(
      (res: JobObjectFailuresWithCount) => ({
        responseMetaData: {
          count: res.total
        },
        items: res.data
      })
    );
  };

  return (
    <EntityList
      entity={EntityListEntities.JOB_OBJECT_STAGE_FAILURES}
      mode='connected'
      classes={{
        className: 'pt-0',
        toolbar: styles.listToolbar,
        listClassName: 'bg-secondary no-shadow border'
      }}
      dataId=''
      dataSource$={fetch}
      listIcon='jobs'
      entityTitle='Failures'
      emptyTitle='No Failed Events Found'
      emptySubTitle='Modify search term to find the desired failed Events'
      showSearch={false}
      shimmerColumnsCount={4}
      newListConnectedTitle='Failed to load some Events'
      newListConnectedSubTitle='We encountered an internal error during data replication. Our team is investigating the issue to identify its cause and is working to resolve it.'
      genericErrorTitle='Error while fetching failed Events'
      genericErrorSubTitle='Retry Fetching the failed Events'
      hideRefresh
      ListComponent={JobObjectStageFailuresTable}
    />
  );
}
